import React, { ChangeEvent } from 'react';
import { useStore } from '../contexts/StoreContext';
import { Store as StoreIcon } from 'lucide-react';

export default function StoreSelector(): React.ReactElement | null {
    const { stores, currentStore, setCurrentStore } = useStore();

    if (stores.length <= 1) return null;

    const handleStoreChange = (e: ChangeEvent<HTMLSelectElement>): void => {
        const store = stores.find(s => s.id === e.target.value);
        setCurrentStore(store || null);
    };

    return (
        <div className="flex items-center space-x-1 sm:space-x-2 bg-gray-100 dark:bg-dark-surface p-1.5 sm:p-2 rounded-lg">
            <StoreIcon size={16} className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
            <select
                data-testid="store-selector"
                className="bg-transparent border-none text-xs sm:text-sm font-medium focus:ring-0 cursor-pointer dark:text-dark-text max-w-[100px] sm:max-w-none truncate"
                value={currentStore?.id || ''}
                onChange={handleStoreChange}
            >
                {stores.map(store => (
                    <option key={store.id} value={store.id}>
                        {store.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
